module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAALCAYAAACzkJeoAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABESURBVChTdY9bEgAgBEXVyizdzipFeXV+mDkXoxHRgA9dasmViCjdw03GQFprA+VNDZRyfbBrkioYJ61groyCKW8eACZwgA9V1J0QUAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/STARTARI.png
// module id = 103
// module chunks = 0